import { SNAP_BASE } from '@/config/domains';

/**
 * Fire-and-forget poke to the render-worker's EmbrFyr relay after a template
 * save. The worker verifies the template exists, then forwards to EmbrFyr's
 * re-bake webhook with the shared secret (which never reaches the browser).
 * EmbrFyr no-ops for templates it hasn't imported, so this is safe to call on
 * every save; misses are backfilled by EmbrFyr's nightly bake cron.
 */
export function notifyEmbrfyrTemplateUpdated(
  templateId: string | null | undefined,
  extras: { slug?: string; shareSlug?: string; source?: string } = {},
): void {
  const id = typeof templateId === 'string' ? templateId.trim() : '';
  if (!id) return;
  try {
    void fetch(`${SNAP_BASE}/api/v1/embrfyr/template-updated`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ templateId: id, ...extras }),
      keepalive: true,
    }).catch((error) => {
      console.warn('[embrfyrTemplateSync] notify failed (cron will backfill):', error);
    });
  } catch {
    // Never let the notify break a save.
  }
}
